import { Box, Flex, Label, RadioButton, Text } from '@modusign/design-system';
import { ProductResDtoInPublic } from '@modusign/openapi-client-subscription/model';

import { PLAN_MONTH_PREMIUM, PLAN_YEAR_PREMIUM } from '@app/features/subscription/constants';
import { useSubscription } from '@app/features/subscription/hooks/subscription';

interface ProductItemProps {
  product: ProductResDtoInPublic;
  checked: boolean;
  onClick: (product: ProductResDtoInPublic) => void;
}

export default function ProductItem({ checked, product, onClick }: ProductItemProps) {
  const { data: subscription } = useSubscription();

  // 프리미엄 요금제 구독 중이고, 대량전송과 링크서명의 경우에만 할인 라벨 띄워줌
  const showSaleLabel =
    subscription &&
    [PLAN_MONTH_PREMIUM, PLAN_YEAR_PREMIUM].includes(subscription.plan?.id ?? '') &&
    ['대량전송', '링크서명'].includes(product.name);

  return (
    <Label display="block" htmlFor={`${product.id}`} mb={0}>
      <Flex
        alignItems="center"
        justifyContent="space-between"
        mb={0}
        p={4}
        sx={{
          cursor: 'pointer',
          backgroundColor: checked ? 'tableBackgroundNeutralSlightlyDark' : 'inherit',
          '&:hover': { backgroundColor: 'tableBackgroundNeutralSlightlyDark' },
        }}
      >
        <Flex alignItems="center" gap={4}>
          <RadioButton
            checked={checked}
            id={product.id}
            weight="lg"
            onClick={() => {
              onClick(product);
            }}
          />
          <Flex flexDirection="column">
            <Text color="textNeutralBase" fontSize="16px" fontWeight="medium">
              {product.name}
            </Text>
            <Text color="textNeutralLight" fontSize="sm">
              {product.description}
            </Text>
          </Flex>
        </Flex>
        <Flex>
          {showSaleLabel && (
            <>
              <Box
                backgroundColor="boxBackgroundNeutralBase"
                borderRadius="3px"
                color="textNeutralLight"
                fontSize="10px"
                fontWeight="medium"
                mr={3}
                px={3}
              >
                할인 중
              </Box>
              <Text
                color="textNeutralLight"
                fontSize="lg"
                fontWeight="medium"
                mr={3}
                sx={{
                  textDecoration: 'line-through',
                  textDecorationColor: '#F96464',
                  textDecorationThickness: '1px',
                }}
              >
                1,900원
              </Text>
            </>
          )}
          <Text fontSize="lg" fontWeight="medium">
            {product.price.toLocaleString()}원
          </Text>
        </Flex>
      </Flex>
    </Label>
  );
}
